import styles from "../styles/SectionLayout.module.css";
import React from 'react';

const SectionLayout = ({ children }) => {

  return (
    <main className={styles.main_container}>
      <div className={styles.section_layout}>{children}</div>
    </main>
  );
};

export default SectionLayout;